<script setup lang="ts">
import { ref } from 'vue'
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { runCommand } from '@/commands/registry'

const emit = defineEmits<{ close: [] }>()
useModal('rotate-arbitrary')
const { t } = useI18n()
const degrees = ref(0)
function run() {
  if (!Number.isFinite(degrees.value) || degrees.value === 0) {
    emit('close')
    return
  }
  void runCommand('image.rotateArbitrary', { degrees: degrees.value })
  emit('close')
}
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')" @keydown.enter="run">
      <h2>{{ t('dialog.rotate.title') }}</h2>
      <label class="field"><span>{{ t('dialog.rotate.angle') }}</span><span class="row"><input v-model.number="degrees" type="number" min="-360" max="360" step="0.1" autofocus /> °</span></label>
      <div class="actions">
        <button @click="emit('close')">{{ t('dialog.cancel') }}</button>
        <button class="primary" @click="run">{{ t('dialog.ok') }}</button>
      </div>
    </div>
  </div>
</template>
